import axios from 'axios';
import { refreshAccessToken } from 'auth/authApi';
import { getAccessToken, getRefreshToken, setTokens, clearTokens } from 'auth/tokenStorage';

const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL
});

api.interceptors.request.use(
    (config) => {
        const token = getAccessToken();
        if (token) config.headers['Authorization'] = `Bearer ${token}`;
        return config;
    },
    (error) => {
        // Gérer les erreurs de configuration
        return Promise.reject(error);
    }
);

// Rafraîchissement automatique du jeton d'accès expiré (connexion automatique),
// avec mutualisation des rafraîchissements simultanés pour éviter les doublons.
let refreshPromise = null;

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const { config, response } = error;
        if (!response || response.status !== 401 || config._retry) {
            return Promise.reject(error);
        }
        const refreshToken = getRefreshToken();
        if (!refreshToken) {
            return Promise.reject(error);
        }
        config._retry = true;
        try {
            if (!refreshPromise) {
                refreshPromise = refreshAccessToken(refreshToken).finally(() => {
                    refreshPromise = null;
                });
            }
            const tokens = await refreshPromise;
            setTokens(tokens);
            config.headers['Authorization'] = `Bearer ${tokens.access}`;
            return api(config);
        } catch (refreshError) {
            clearTokens();
            window.dispatchEvent(new Event('auth:logout'));
            return Promise.reject(error);
        }
    }
);

export default api;
